export default function InstantTravelerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M25.9 46.7906H5.03125V5.03125H38.4344V21.7438" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M11.2881 13.3984H32.1787" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M11.2881 21.7344H32.1787" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M11.2881 30.0781H25.9225" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M11.2881 38.4453H25.9225" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M40.5562 50.925H40.425C37.4719 50.0343 34.8829 48.2186 33.0398 45.7453C31.1966 43.272 30.1967 40.272 30.1875 37.1875V28.9187L40.5344 25.9219L51.0781 28.9187V37.1219C51.0723 40.256 50.0405 43.302 48.1405 45.7945C46.2405 48.287 43.5768 50.0889 40.5562 50.925Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
    </svg>
  );
}
